<section class="debt-perf-chart" (click)="closeDropdowns()" (keydown.escape)="closeDropdowns()">
  <!-- Header: título + subtítulo + controles de séries/benchmark (mesmo padrão dos gráficos DI1/PTAX) -->
  <div class="debt-perf-chart__header" (click)="$event.stopPropagation()">
    <div class="debt-perf-chart__heading">
      <div class="debt-perf-chart__title-row">
        <h3 class="debt-perf-chart__title">Performance da Dívida · Acumulada</h3>
      </div>
      <div class="debt-perf-chart__subtitle">Marcação na curva · comparada ao benchmark</div>
    </div>

    <!-- Dropdown de séries auxiliares (botão + painel) -->
    <div class="debt-perf-chart__bench-wrap">
      <button
        type="button"
        class="debt-perf-chart__bench-btn"
        [class.debt-perf-chart__bench-btn--open]="seriesDropdownOpen"
        [disabled]="isLoading || !chartData"
        (click)="toggleSeriesDropdown(); $event.stopPropagation()"
        aria-haspopup="listbox"
        [attr.aria-expanded]="seriesDropdownOpen">
        <span class="debt-perf-chart__bench-btn-label">Séries</span>
        <i
          class="pi pi-chevron-down debt-perf-chart__bench-btn-chevron"
          [class.debt-perf-chart__bench-btn-chevron--open]="seriesDropdownOpen"></i>
      </button>

      @if (seriesDropdownOpen) {
        <div class="debt-perf-chart__bench-panel" role="listbox" (click)="$event.stopPropagation()">
          <div class="debt-perf-chart__bench-panel-heading">SÉRIES ADICIONAIS</div>

          @for (opt of availableSeriesOptions; track opt.label) {
            <button
              type="button"
              class="debt-perf-chart__bench-option"
              [class.debt-perf-chart__bench-option--selected]="isSeriesVisible(opt.label)"
              role="option"
              [attr.aria-selected]="isSeriesVisible(opt.label)"
              (click)="toggleSeries(opt.label)">
              <span
                class="debt-perf-chart__series-swatch"
                [class.debt-perf-chart__series-swatch--dashed]="opt.dashed"
                [style.--swatch-color]="opt.color"></span>
              <span class="debt-perf-chart__bench-option-label">{{ opt.label }}</span>
              @if (isSeriesVisible(opt.label)) {
                <i class="pi pi-check debt-perf-chart__bench-option-check"></i>
              }
            </button>
          } @empty {
            <div class="debt-perf-chart__series-empty">Nenhuma série adicional disponível.</div>
          }
        </div>
      }
    </div>

    <!-- Dropdown de período (recorte em memória da curva já carregada — sem chamada ao backend) -->
    <div class="debt-perf-chart__bench-wrap">
      <button
        type="button"
        class="debt-perf-chart__bench-btn"
        [class.debt-perf-chart__bench-btn--open]="periodDropdownOpen"
        [disabled]="isLoading || !chartData"
        (click)="togglePeriodDropdown(); $event.stopPropagation()"
        aria-haspopup="listbox"
        [attr.aria-expanded]="periodDropdownOpen">
        <span class="debt-perf-chart__bench-btn-label">Período</span>
        @if (periodPreset === 'custom' && (periodFrom || periodTo)) {
          <span class="debt-perf-chart__bench-btn-value">
            {{ periodFrom ? (periodFrom | vaultDate) : '…' }} –
            {{ periodTo ? (periodTo | vaultDate) : '…' }}
          </span>
        } @else {
          <span class="debt-perf-chart__bench-btn-value">{{ periodButtonValue }}</span>
        }
        <i
          class="pi pi-chevron-down debt-perf-chart__bench-btn-chevron"
          [class.debt-perf-chart__bench-btn-chevron--open]="periodDropdownOpen"></i>
      </button>

      @if (periodDropdownOpen) {
        <div
          class="debt-perf-chart__bench-panel debt-perf-chart__period-panel"
          role="listbox"
          (click)="$event.stopPropagation()">
          <div class="debt-perf-chart__bench-panel-heading">PERÍODO EXIBIDO</div>

          @for (opt of periodPresets; track opt.value) {
            <button
              type="button"
              class="debt-perf-chart__bench-option"
              [class.debt-perf-chart__bench-option--selected]="periodPreset === opt.value"
              role="option"
              [attr.aria-selected]="periodPreset === opt.value"
              (click)="selectPeriodPreset(opt.value)">
              <span class="debt-perf-chart__bench-option-label">{{ opt.label }}</span>
              @if (periodPreset === opt.value) {
                <i class="pi pi-check debt-perf-chart__bench-option-check"></i>
              }
            </button>
          }

          @if (periodPreset === 'custom') {
            <div class="debt-perf-chart__period-custom">
              <app-calendar
                [label]="'De'"
                [labelSize]="'small'"
                [theme]="'medium'"
                [inputId]="'debt-perf-period-from'"
                [(ngModel)]="periodFrom">
              </app-calendar>
              <app-calendar
                [label]="'Até'"
                [labelSize]="'small'"
                [theme]="'medium'"
                [inputId]="'debt-perf-period-to'"
                [(ngModel)]="periodTo">
              </app-calendar>
            </div>
            <div class="debt-perf-chart__bench-actions">
              <button type="button" class="debt-perf-chart__link-btn" (click)="clearPeriod()">
                Limpar
              </button>
              <button
                type="button"
                class="debt-perf-chart__apply-btn"
                [disabled]="!periodFrom && !periodTo"
                (click)="applyCustomPeriod()">
                Aplicar
              </button>
            </div>
          }
        </div>
      }
    </div>

    <!-- Período aplicado aos cards de economia (card 3323): economia na data final e no período -->
    @if (canApplyPeriodToCards) {
      <span
        class="debt-perf-chart__cards-period"
        pTooltip="Os cards de economia passam a mostrar a economia na data final do período e quanto foi gerado dentro dele, contando só os derivativos já contratados naquela data."
        tooltipPosition="top">
        <app-switch
          label="Aplicar aos cards"
          [checked]="isPeriodAppliedToCards"
          [disabled]="isLoading"
          (sendChecked)="togglePeriodOnCards($event)"></app-switch>
      </span>
    }

    <!-- Dropdown de benchmark (botão + painel) -->
    <div class="debt-perf-chart__bench-wrap">
      <button
        type="button"
        class="debt-perf-chart__bench-btn"
        [class.debt-perf-chart__bench-btn--open]="benchDropdownOpen"
        [disabled]="isLoading"
        (click)="toggleBenchDropdown(); $event.stopPropagation()"
        aria-haspopup="listbox"
        [attr.aria-expanded]="benchDropdownOpen">
        <span class="debt-perf-chart__bench-btn-label">Benchmark</span>
        <span class="debt-perf-chart__bench-btn-value">{{ benchmarkButtonValue }}</span>
        <i
          class="pi pi-chevron-down debt-perf-chart__bench-btn-chevron"
          [class.debt-perf-chart__bench-btn-chevron--open]="benchDropdownOpen"></i>
      </button>

      @if (benchDropdownOpen) {
        <div class="debt-perf-chart__bench-panel" role="listbox" (click)="$event.stopPropagation()">
          <div class="debt-perf-chart__bench-panel-heading">COMPARAR COM</div>

          @for (opt of benchmarkOptions; track opt.value) {
            <button
              type="button"
              class="debt-perf-chart__bench-option"
              [class.debt-perf-chart__bench-option--selected]="benchmark === opt.value"
              [disabled]="isBusy"
              role="option"
              [attr.aria-selected]="benchmark === opt.value"
              (click)="selectBenchmark(opt.value)">
              <span class="debt-perf-chart__bench-option-label">{{ opt.label }}</span>
              @if (benchmark === opt.value) {
                <i class="pi pi-check debt-perf-chart__bench-option-check"></i>
              }
            </button>
          }

          <!-- Spread stepper -->
          <div class="debt-perf-chart__spread-row">
            <span class="debt-perf-chart__spread-label">Spread (a.a.)</span>
            <button
              type="button"
              class="debt-perf-chart__spread-btn"
              [disabled]="spread <= 0 || isBusy"
              (click)="decSpread()"
              aria-label="Diminuir spread">
              −
            </button>
            <div class="debt-perf-chart__spread-input-wrap">
              <span class="debt-perf-chart__spread-prefix">+</span>
              <input
                type="text"
                class="debt-perf-chart__spread-input"
                inputmode="decimal"
                autocomplete="off"
                aria-label="Spread anual"
                [disabled]="isBusy"
                [(ngModel)]="spreadInput"
                (ngModelChange)="onSpreadInputChange($event)"
                (blur)="normalizeSpreadInput()" />
              <span class="debt-perf-chart__spread-suffix">%</span>
            </div>
            <button
              type="button"
              class="debt-perf-chart__spread-btn"
              [disabled]="spread >= 20 || isBusy"
              (click)="incSpread()"
              aria-label="Aumentar spread">
              +
            </button>
          </div>

          <div class="debt-perf-chart__bench-actions">
            <button
              type="button"
              class="debt-perf-chart__apply-btn"
              [disabled]="isBusy || !selectedCompanyIds?.length"
              (click)="applyBenchmark()">
              Aplicar
            </button>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Skeleton apenas quando ainda NÃO há curva para mostrar. Quando a curva do snapshot já
       pintou, o SSE complementar (cotações USD/EUR ou simulação) roda em segundo plano com a
       barra de progresso discreta abaixo — nunca esconda uma curva já renderizada. -->
  @if (isBusy && !chartData) {
    <div class="debt-perf-chart__skeleton" aria-busy="true" aria-live="polite">
      <app-cog-loading-spinner [size]="48"></app-cog-loading-spinner>
      <span class="debt-perf-chart__stream-msg">
        {{ streamMessage || 'Carregando performance da dívida...' }}
      </span>
    </div>
  }

  <!-- Progresso discreto do SSE com a curva do snapshot ainda visível -->
  @if (isBusy && chartData) {
    <div class="debt-perf-chart__inline-progress" aria-live="polite">
      <app-cog-loading-spinner [size]="16"></app-cog-loading-spinner>
      <span>{{ streamMessage || 'Atualizando curva...' }}</span>
    </div>
  }

  <!-- Mensagem de erro (mantém curva anterior visível abaixo) -->
  @if (errorMessage) {
    <div class="debt-perf-chart__error">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ errorMessage }}</span>
    </div>
  }

  <!-- Gráfico principal -->
  @if (chartData) {
    <div class="debt-perf-chart__plot">
      <img
        class="debt-perf-chart__watermark"
        src="assets/images/logo-cognito.svg"
        alt=""
        aria-hidden="true" />
      <div class="debt-perf-chart__chart-wrapper">
        <app-performance-main-chart
          [chartData]="chartData"
          [chartOptions]="chartOptions"
          [chartHeight]="'340'"
          [embedded]="true">
        </app-performance-main-chart>
      </div>
    </div>
    <!-- Período escolhido sem nenhum ponto da curva (ex.: janela anterior à 1ª dívida) -->
    @if (periodHasNoPoints) {
      <p class="debt-perf-chart__period-empty">
        <i class="pi pi-calendar-times"></i>
        Nenhum ponto da curva no período escolhido.
        <button type="button" class="debt-perf-chart__link-btn" (click)="clearPeriod()">
          Mostrar tudo
        </button>
      </p>
    }
    <!-- Dica exibida apenas quando não há linha de benchmark renderizada (nem snapshot CDI nem simulação) -->
    @if (showBenchmarkHint) {
      <p class="debt-perf-chart__hint">
        <i class="pi pi-info-circle"></i>
        Selecione um benchmark para comparar com a curva de performance.
      </p>
    }
  }

  <!-- Estado vazio: sem dados de snapshot, sem carregamento em andamento e sem erro -->
  @if (!isBusy && !chartData && !errorMessage) {
    <div class="debt-perf-chart__empty">
      @if (isNoBenchmark) {
        <i class="pi pi-sliders-h"></i>
        <span>Defina o benchmark da empresa para ver a performance da dívida.</span>
        <span class="debt-perf-chart__empty-hint">
          O cenário compara as operações elegíveis ao benchmark configurado da empresa (ex.: CDI +
          2,00%).
        </span>
      } @else {
        <i class="pi pi-chart-line"></i>
        <span>Nenhuma curva de performance disponível para a seleção atual.</span>
        <span class="debt-perf-chart__empty-hint">
          O snapshot diário ainda não foi gerado ou não há operações elegíveis.
        </span>
      }
    </div>
  }
</section>
